import axios from 'axios';
import {
  apiUrls,
  dataStorageKeywords,
  DAY_IN_MILLISECONDS,
  errorMessages,
  protectedURL,
  routeURL,
  userRoles,
} from 'src/utils/properties.utils';
import Cookies from 'js-cookie';
import { handleSessionExpiration } from 'src/utils/auth.utils';
import {
  decodeAccessToken,
  handleLocalStorageData,
} from 'src/utils/token.utils';
import { calculateTimeToExpire } from 'src/utils/text.utils';
import { getHighestPriorityRole } from 'src/utils/roles.utils';

const axiosTokenInstance = axios.create({
  baseURL: apiUrls.BASEURL,
});

const axiosInstance = axios.create({
  baseURL: apiUrls.BASEURL,
});

axiosTokenInstance.interceptors.request.use(
  async (config) => {
    const accessToken = Cookies.get(dataStorageKeywords.ACCESS_TOKEN);

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    } else {
      const refreshToken = Cookies.get(dataStorageKeywords.REFRESH_TOKEN);

      if (refreshToken) {
        try {
          const { data } = await axios.post(
            apiUrls.BASEURL + apiUrls.REFRESH_ACESS_TOKEN,
            null,
            {
              headers: {
                Authorization: `Bearer ${refreshToken}`,
              },
            }
          );

          const newAccessToken = data.accessToken;
          const decodedAccessToken = decodeAccessToken(newAccessToken);
          const accesstokenExpiration = decodedAccessToken.exp;
          const accessTimeToExpire = calculateTimeToExpire(
            accesstokenExpiration
          );
          const roles = decodedAccessToken.roles;

          const currentUrl = window.location.pathname;

          if (Object.values(protectedURL).includes(currentUrl)) {
            const highestRole = getHighestPriorityRole(roles);

            if (
              highestRole === userRoles.OWNER ||
              highestRole === userRoles.ADMIN
            ) {
              // Owner/Admin has access, continue
            } else {
              window.location.href = routeURL.UNAUTHORIZED_404;
            }
          }

          handleLocalStorageData(roles);

          Cookies.set(dataStorageKeywords.ACCESS_TOKEN, newAccessToken, {
            expires: accessTimeToExpire / DAY_IN_MILLISECONDS,
          });
          config.headers.Authorization = `Bearer ${newAccessToken}`;
        } catch (error) {
          handleSessionExpiration();
          return Promise.reject(error);
        }
      } else {
        handleSessionExpiration();
        return Promise.reject(new Error(errorMessages.SESSION_REFRESH_FAILED));
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosTokenInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 402 &&
      error?.response?.data?.code === 'SUBSCRIPTION_PAYMENT_REQUIRED'
    ) {
      const status =
        error?.response?.data?.data?.status ||
        error?.response?.data?.subscriptionStatus ||
        error?.response?.data?.status;

      window.dispatchEvent(
        new CustomEvent('billing-payment-required', {
          detail: { subscriptionStatus: status },
        })
      );
    }

    return Promise.reject(error);
  }
);

export { axiosTokenInstance, axiosInstance };
